import _parseDate from 'date-fns/parse';
import { toDate as _toDate } from 'qc-to_date';

export function isValidDate(year, month, day) {
  const d = new Date(year, month, day);
  if (
    d.getFullYear().toString() === year.toString() &&
    d.getMonth().toString() === month.toString() &&
    d.getDate().toString() === day.toString()
  ) {
    return true;
  }
  return false;
}

export function toDate(dateLike, defVal) {
  let date = null;
  if (
    dateLike &&
    typeof dateLike === 'object' &&
    'year' in dateLike &&
    'month' in dateLike
  ) {
    const { year } = dateLike;
    const month = dateLike.month - 1;
    const day = dateLike.day || 1;
    const hours = dateLike.hours || 1;
    const minutes = dateLike.minutes || 0;
    const seconds = dateLike.seconds || 0;
    date = new Date(year, month, day, hours, minutes, seconds);
  } else if (typeof dateLike === 'string') {
    date = _parseDate(dateLike);
  } else {
    date = _toDate(dateLike, defVal);
  }
  return date;
}

const DateUtils = {
  isValidDate,
  toDate,
};

export default DateUtils;
